import { PlayerContextState } from "../../../PlayerContext";
import { EquipmentSlot } from "../../Equipment";
import { ItemParams } from "../../Item";
import { EquippableItem } from "../EquippableItem";

class ReinforcedIronMail extends EquippableItem {
  getId(): string {
    return "reinforcedIronMail";
  }

  getPicture() {
    return require("./reinforcedIronMail.png");
  }

  getBaseName(): string {
    return "Reinforced Iron Mail";
  }

  getDescription(): string | undefined {
    return "An Iron Mail that has been enhanced with extra material to provide more protection.";
  }

  getDefenseBonus(state: PlayerContextState, params: ItemParams): number {
    return 22;
  }

  getSlot(): EquipmentSlot {
    return EquipmentSlot.Body;
  }

  getSalePrice(): number {
    return 5000;
  }

  getCraftingSchoolLevelRequirements() {
    return { Conjuration: 11 };
  }

  getCraftingMaterialsBase() {
    return {
      resources: {
        Iron: 2000,
        Temperature: 3200,
      },
      items: { ironArmor: 1 },
    };
  }
}

export default new ReinforcedIronMail();
